import type { AdSettingEntry, AdSettingEntryWithName } from '../api';

function adSettingsMapper(
  input: Record<string, AdSettingEntry>,
): AdSettingEntryWithName[] {
  return Object.entries(input).map(([key, value]) => ({
    name: key,
    ...value,
  }));
}

export default adSettingsMapper;